import { render, staticRenderFns } from "./ReviewBoard.vue?vue&type=template&id=77b121fd&scoped=true"
import script from "./ReviewBoard.vue?vue&type=script&lang=js"
export * from "./ReviewBoard.vue?vue&type=script&lang=js"
import style0 from "./ReviewBoard.vue?vue&type=style&index=0&id=77b121fd&prod&scoped=true&lang=css"
import style1 from "./ReviewBoard.vue?vue&type=style&index=1&id=77b121fd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b121fd",
  null
  
)

export default component.exports